<template>
  <div>
    <div>
      <vue-headful 
      title="imgsurv" 
      description="Looking for free image share sites? Imgsurv is a free and anonymous temporary image hosting service. Start your private image hosting without an account! Sust share the link!" 
      url="https://www.imgsurv.com/" />
    </div>

    <div class="privacy-policy">    
      <v-container class="post-section-parent">
          <v-layout>
              <v-flex xs12>
                  <a class="text-xs-center" style="color: inherit;" href="https://imgsurv.com/TOUPP.html">
                    Terms of Use and Privacy Policy</a>
                  <br/>
                  <a class="text-xs-center" style="color: inherit;" href="https://imgsurv.com/acknowledgements.html">
                    Acknowledgements</a>
                  <br/>
                  <address>
                      Contact an admin <a href="mailto:admin@imgsurv.com">admin@imgsurv.com</a> 
                  </address>
              </v-flex>
          </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import Propeller from "./ads/Propeller";

export default {
  name: "Footer",
  components:{
    Propeller
  },
  data() {
    return {
      defaultActive: 0
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.post-section-parent{
  text-align: center;
}

.post-section-title{
  display: inline-block;
}

.post-section-date{
  display: inline-block;
}

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue